import { SignatoryData, Signatory as SignatoryType } from "../../types";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { onUpdateFormData } from "../../reducers/onboardingDataReducer";
import { RoundedButton } from "@almafintech/react-components/RoundedButton";
import DeleteIcon from "../../assets/images/icons/ui/delete.svg?react";
import styles from "./Signatories.module.scss";
import {
  onUpdatePrimaryButtonModal,
  openModal,
} from "../../reducers/modalReducer";

interface SignatoryProps {
  signatory: SignatoryType;
  onClick?: () => void;
  index: number;
  onRemove?: (signatories: SignatoryData[]) => void;
}

const Signatory = ({ signatory, index, onClick, onRemove }: SignatoryProps) => {
  const { signatoryContainer, active, currentSignatory, icon } = styles;

  const dispatch = useAppDispatch();

  const { formValues } = useAppSelector((state) => state.onboardingData);
  const { activeIndex } = useAppSelector((state) => state.collectionData);

  const signatories = formValues?.signatories;

  const currentSignatoryIsEmpty = () => {
    if (!signatory) return true;
    return Object.values(signatory).every((value) => value === "");
  };

  const removeSignatory = () => {
    const newSignatories = [...signatories];
    newSignatories.splice(index - 1, 1);
    onRemove && onRemove(newSignatories);
    dispatch(onUpdateFormData({ signatories: newSignatories }));
  };

  const handleRemove = () => {
    if (!currentSignatoryIsEmpty()) {
      dispatch(openModal({ name: "delete-signatory-preconfirmation" })) &&
        dispatch(
          onUpdatePrimaryButtonModal({
            text: "Sí, eliminar",
            action: removeSignatory,
          })
        );
    } else {
      removeSignatory();
    }
  };

  const isActive = activeIndex === index;
  const isAnAdditionalSignatory = index !== 1;

  return (
    <div
      className={`${signatoryContainer} ${isActive && active} ${
        !isAnAdditionalSignatory && currentSignatory
      }`}
      onClick={onClick}
      id={`signatory-${index}`}
    >
      <h3>Firmante {index}</h3>
      <p>
        {signatory?.name !== "" ? signatory?.name : <span>Nombre</span>}{" "}
        {signatory?.lastName !== "" ? (
          signatory?.lastName
        ) : (
          <span>Apellido</span>
        )}{" "}
        {!isAnAdditionalSignatory && "(Tú)"}
      </p>
      {isAnAdditionalSignatory && (
        <RoundedButton
          icon={<DeleteIcon />}
          buttonType="empty"
          className={icon}
          onClick={handleRemove}
        ></RoundedButton>
      )}
    </div>
  );
};

export default Signatory;
